import { render, staticRenderFns } from "./SidebarEdit.vue?vue&type=template&id=0fb41069"
import script from "./SidebarEdit.vue?vue&type=script&lang=js"
export * from "./SidebarEdit.vue?vue&type=script&lang=js"
import style0 from "./SidebarEdit.vue?vue&type=style&index=0&id=0fb41069&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fb41069')) {
      api.createRecord('0fb41069', component.options)
    } else {
      api.reload('0fb41069', component.options)
    }
    module.hot.accept("./SidebarEdit.vue?vue&type=template&id=0fb41069", function () {
      api.rerender('0fb41069', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/SidebarEdit.vue"
export default component.exports